module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-blue@2x-829607e9.png";